import { AxiosInstance } from 'axios';
import { IItem } from 'src/views/Admin/Items/types';
import { insertId } from '../../insertId';
import { toResponse } from '../../genericToResponse';

export default (api: AxiosInstance, url: string) => async (
  item: IItem,
  withWarnings = false
) => {
  const urlWithId = insertId(url, item.id);
  const urlWithWarningParam = withWarnings
    ? `${urlWithId}?confirmedWarnings=true`
    : urlWithId;
  const response = await api.put(urlWithWarningParam, item);
  return toResponse(response.data) as IItem;
};



// WEBPACK FOOTER //
// ./src/services/api/admin/items/update.ts